import { Duration } from 'luxon';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIdleTimer, workerTimers } from 'react-idle-timer';
import { ButtonCancel, ButtonRow, ButtonSave } from '@arc/frontend/ui-buttons';
import { Modal } from '@arc/frontend/ui-modal';
import { IDLE_TIMEOUT_MS, WARNING_TIMEOUT_MS } from '@arc/shared/data-idle-timeout';
import { ms } from '@arc/shared/util-js';
export function InactiveModal({
  logout,
  refreshSession
}) {
  const {
    t
  } = useTranslation('common');
  const [showInactiveModal, setShowInactiveModal] = useState(false);
  const handleOnPrompt = () => {
    setShowInactiveModal(true);
  };
  const handleOnActive = () => {
    setShowInactiveModal(false);
  };
  const handleOnIdle = () => {
    logout();
  };
  const handleOnAction = () => {
    // this is triggered every [throttle] ms
    // our goal is to have the backend update the cookie expiration
    void refreshSessionOrLogout();
  };
  const refreshSessionOrLogout = async () => {
    const session = await refreshSession();
    if (!session) {
      logout();
    }
  };
  const idleMethods = useIdleTimer({
    timers: workerTimers,
    timeout: IDLE_TIMEOUT_MS,
    promptBeforeIdle: WARNING_TIMEOUT_MS,
    onPrompt: handleOnPrompt,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    throttle: 5 * ms.minutes,
    // update onAction every 5 minutes
    stopOnIdle: true,
    crossTab: true
  });
  const handleStay = async () => {
    idleMethods.reset();
    await refreshSessionOrLogout();
    handleOnActive();
  };
  const handleLogout = () => {
    logout(true);
  };
  useEffect(() => {
    // If a focus trap that is not a modal (such as HUB's date pickers) is
    // active when the modal is shown, it could loop with the modal's focus trap
    // and cause a "RangeError: Maximum call stack size exceeded." Blurring the
    // active element when opening the modal seems to prevent this issue.
    if (showInactiveModal) {
      document.activeElement?.blur?.();
    }
  }, [showInactiveModal]);
  return <Modal show={showInactiveModal}>
			<div>
				<Modal.Header>{t('inactivity warning')}</Modal.Header>
				<Modal.Body>
					{t('inactivity message', {
          durationMinutes: Duration.fromMillis(IDLE_TIMEOUT_MS).shiftTo('minutes').minutes
        })}
				</Modal.Body>
				<ButtonRow left={<ButtonCancel onClick={handleLogout}>
							{t('Log out now')}
						</ButtonCancel>} right={<ButtonSave onClick={handleStay}>{t('Stay logged in')}</ButtonSave>} outerStyle={{
        marginBottom: '0px'
      }} />
			</div>
		</Modal>;
}